"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePosition = void 0;
const tslib_1 = require("tslib");
const ImageWidget_1 = tslib_1.__importStar(require("./ImageWidget"));
const LabeledInputFieldWidget_1 = tslib_1.__importDefault(require("./LabeledInputFieldWidget"));
var ImagePosition;
(function (ImagePosition) {
    ImagePosition[ImagePosition["BEFORE"] = 0] = "BEFORE";
    ImagePosition[ImagePosition["AFTER"] = 1] = "AFTER";
})(ImagePosition = exports.ImagePosition || (exports.ImagePosition = {}));
// Component rendered in the user interface
// <div style="display: flex; flex-direction: row">
//   <src="*.svg" alt="image-description">
//   <input type="text">
// </div>
// or
// <div style="display: flex; flex-direction: row">
//   <input type="text">
//   <src="*.svg" alt="image-description">
// </div>
class LabeledInputFieldWithImageWidget extends LabeledInputFieldWidget_1.default {
    constructor(args) {
        super({ ...args });
    }
    getImageWidget() {
        return this.imageWidget;
    }
    decorateLabeledInputFieldWidgetElement(args) {
        const { imageSrc, imageAlt, imagePosition = ImagePosition.BEFORE, overrideEventMouseClick, imageOnClick } = args;
        this.imageWidget = new ImageWidget_1.default({ src: imageSrc, alt: imageAlt, imageDimension: ImageWidget_1.ImageDimensions.FIELD });
        this.element = document.createElement("div");
        this.element.classList.add("image-input-container", "flex-row");
        this.fieldElementContainer = this.element;
        this.element.addEventListener("click", overrideEventMouseClick || (event => {
            if (event.target !== this.fieldElement && event.target !== this.imageWidget.element) {
                event.stopPropagation();
                this.fieldElement.click();
            }
        }));
        if (!imageOnClick) {
            this.imageWidget.element.classList.add("image-not-clickable");
        }
        else {
            this.imageWidget.element.addEventListener("click", event => {
                event.stopPropagation();
                imageOnClick();
            });
        }
        if (imagePosition === ImagePosition.BEFORE) {
            this.add(this.imageWidget);
            this.add(this.fieldElement);
        }
        else if (imagePosition === ImagePosition.AFTER) {
            this.add(this.fieldElement);
            this.add(this.imageWidget);
        }
        this.decorateLabeledInputFieldWithImageWidgetElement(args);
    }
}
exports.default = LabeledInputFieldWithImageWidget;
//# sourceMappingURL=LabeledInputFieldWithImageWidget.js.map